import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-is-loading',
  templateUrl: './is-loading.component.html',
  styleUrls: ['./is-loading.component.scss'],
})


export class IsLoadingComponent
{
  @Input() type: 'spinner' | 'progress-bar' | 'buffer' | 'text' | 'dots' | 'progress-text' | 'login' = 'spinner';
  @Input() size: number;
  @Input() stroke: number;
  @Input() align?: string;
  @Input() color?: string;
  @Input() trackColor?: string;
  @Input() customClass?: string;
  @Input() text?: string;

}
